<div [formGroup]="parentFormGroup" [ngClass]="componentClass" [class.red]="textColor == 'red'" [class.green]="textColor == 'green'" [class.black]="textColor =='black'" [class.no-label]="!label" [class.error]="isError" [class.disabled]="isDisabled" class="f-form_input">

   <span *ngIf="showPhNumber" [class.number-ph]="showPhNumber">+63 |</span>
   <input #input
           [type]="type"
           [class.with-number]="showPhNumber"
           [class.off-password]="!isEyesHide"
           [formControlName]="controlName"
           [id]="controlName"
           [name]="controlName"
           [attr.placeholder]="placeholder"
           [attr.required]="isRequired ? '' : null"
           [attr.maxlength]="maxlength"
           [no-special-char]="noSpecialChar"
           [number-only]="numberOnly"
           (input)="onSearch($event)"/>
    <label class="label" [for]="controlName" [innerHTML]="label" *ngIf="label"></label>
    <button #button type="button" class="f-button--link btn-ico" *ngIf="showButton">
       <span class="atram-ico ico-error"></span>
     </button>
     <button #button type="button" class="f-button--link btn-ico" *ngIf="showSearchButton" (click)="onClick($event)">
         <span class="atram-ico ico-search"></span>
      </button>
      <button #button type="button" class="f-button--link btn-ico" *ngIf="showEyeButton" (click)="onClickEye()">
         <span [class.ico-eyes-hide]="isEyesHide" [class.ico-eyes-show]="!isEyesHide" class="atram-ico"></span>
      </button>
  </div>
  